webpackJsonp([114276838955818,60335399758886],{

/***/ 394:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"descriptionLong":"Raise money for charity with every browser tab you open. It doesn't cost you a thing.","descriptionShort":"Raise money for charity with every browser tab you open.","keywords":"tab for a cause, charity, tab, cause, giving, extension, browser, advertising","metaTagCallToAction":"Join me on Tab for a Cause!","title":"Tab for a Cause","twitterHandle":"@TabForACause"}}},"layoutContext":{}}

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(672);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(394);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(5);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(9);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(6);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(8);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _helpers = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      userSelect: 'none',
	      fontSize: 24,
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	    colorAction: {
	      color: theme.palette.action.active
	    },
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	    colorError: {
	      color: theme.palette.error.main
	    }
	  };
	};
	
	function SvgIcon(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      color = props.color,
	      nativeColor = props.nativeColor,
	      titleAccess = props.titleAccess,
	      viewBox = props.viewBox,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'nativeColor', 'titleAccess', 'viewBox']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), classNameProp);
	
	  return _react2.default.createElement(
	    'svg',
	    (0, _extends3.default)({
	      className: className,
	      focusable: 'false',
	      viewBox: viewBox,
	      color: nativeColor,
	      'aria-hidden': titleAccess ? 'false' : 'true'
	    }, other),
	    titleAccess ? _react2.default.createElement(
	      'title',
	      null,
	      titleAccess
	    ) : null,
	    children
	  );
	}
	
	SvgIcon.propTypes =  false ? {
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * Useful to extend the style applied to components.
	   */
	  classes: _propTypes2.default.object.isRequired,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
	   */
	  color: _propTypes2.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  nativeColor: _propTypes2.default.string,
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes2.default.string,
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : {};
	
	SvgIcon.defaultProps = {
	  color: 'inherit',
	  viewBox: '0 0 24 24'
	};
	
	SvgIcon.muiName = 'SvgIcon';
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSvgIcon' })(SvgIcon);

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SvgIcon = __webpack_require__(272);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SvgIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1614:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgIcon = __webpack_require__(32);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5,3H19C20.1,3 21,3.9 21,5V19C21,20.1 20.1,21 19,21H5C3.9,21 3,20.1 3,19V5C3,3.9 3.9,3 5,3M18,5H15.5C13.57,5 12,6.57 12,8.5V11H10V14H12V21H15V14H18V11H15V9C15,8.45 15.45,8 16,8H18V5Z' })
	  );
	};

/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgIcon = __webpack_require__(32);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z' })
	  );
	};

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Divider = __webpack_require__(329);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FacebookBox = __webpack_require__(1614);
	
	var _FacebookBox2 = _interopRequireDefault(_FacebookBox);
	
	var _Twitter = __webpack_require__(1617);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _logoGrey = __webpack_require__(1768);
	
	var _logoGrey2 = _interopRequireDefault(_logoGrey);
	
	var _theme = __webpack_require__(46);
	
	var _navigation = __webpack_require__(89);
	
	var _Link = __webpack_require__(139);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _IconWrapper = __webpack_require__(663);
	
	var _IconWrapper2 = _interopRequireDefault(_IconWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    var style = this.props.style;
	
	    var footerLinkStyle = {
	      color: _theme.lightestTextColor,
	      fontSize: 12,
	      margin: 20
	    };
	    var hoverLinkStyle = {
	      color: _theme.lighterTextColor
	    };
	    var socialIconStyle = {
	      color: _theme.lightestTextColor,
	      width: 20,
	      height: 20
	    };
	    var socialIconHoverStyle = {
	      color: _theme.lighterTextColor
	    };
	    return _react2.default.createElement(
	      'div',
	      {
	        style: _extends({}, {
	          background: _theme.lightestShadingColor,
	          paddingTop: 1,
	          paddingBottom: 20,
	          paddingLeft: 40,
	          paddingRight: 40
	        }, style)
	      },
	      _react2.default.createElement(_Divider2.default, { style: { width: '100%', marginBottom: 20 } }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            justifyContent: 'space-between'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              justifyContent: 'flex-start',
	              flexWrap: 'nowrap',
	              alignItems: 'center'
	            }
	          },
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/' },
	            _react2.default.createElement('img', { src: _logoGrey2.default, style: { height: 43 } })
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                marginLeft: 30,
	                display: 'flex',
	                flexWrap: 'wrap',
	                justifyContent: 'flex-start'
	              }
	            },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: _navigation.externalHelpURL,
	                style: footerLinkStyle,
	                hoverStyle: hoverLinkStyle
	              },
	              'Help'
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: _navigation.adblockerWhitelistingURL,
	                style: footerLinkStyle,
	                hoverStyle: hoverLinkStyle
	              },
	              'Adblockers'
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: _navigation.financialsURL,
	                style: footerLinkStyle,
	                hoverStyle: hoverLinkStyle
	              },
	              'Financials'
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: _navigation.termsURL,
	                style: footerLinkStyle,
	                hoverStyle: hoverLinkStyle
	              },
	              'Terms'
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: _navigation.privacyPolicyURL,
	                style: footerLinkStyle,
	                hoverStyle: hoverLinkStyle
	              },
	              'Privacy'
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: _navigation.teamURL,
	                style: footerLinkStyle,
	                hoverStyle: hoverLinkStyle
	              },
	              'Team'
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: _navigation.contactUsURL,
	                style: footerLinkStyle,
	                hoverStyle: hoverLinkStyle
	              },
	              'Contact'
	            ),
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: _navigation.jobsURL,
	                style: footerLinkStyle,
	                hoverStyle: hoverLinkStyle
	              },
	              'Jobs'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', alignItems: 'center', paddingTop: 4 } },
	          _react2.default.createElement(
	            _Link2.default,
	            { to: _navigation.facebookPageURL, style: { margin: 12 } },
	            _react2.default.createElement(
	              _IconWrapper2.default,
	              {
	                style: socialIconStyle,
	                hoverStyle: socialIconHoverStyle
	              },
	              _react2.default.createElement(_FacebookBox2.default, null)
	            )
	          ),
	          _react2.default.createElement(
	            _Link2.default,
	            { to: _navigation.twitterPageURL, style: { margin: 12 } },
	            _react2.default.createElement(
	              _IconWrapper2.default,
	              {
	                style: socialIconStyle,
	                hoverStyle: socialIconHoverStyle
	              },
	              _react2.default.createElement(_Twitter2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.Component);
	
	Footer.propTypes = {
	  style: _propTypes2.default.object
	};
	
	Footer.defaultProps = {
	  style: {}
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(531);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logoWithText = __webpack_require__(1769);
	
	var _logoWithText2 = _interopRequireDefault(_logoWithText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.headerLogoClick = function headerLogoClick(e) {
	    if (this.props.onHeaderLogoClick) {
	      e.preventDefault();
	      this.props.onHeaderLogoClick();
	    }
	  };
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          paddingTop: 20,
	          paddingBottom: 20,
	          paddingLeft: 40,
	          paddingRight: 40
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            justifyContent: 'flex-start'
	          }
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/', onClick: this.headerLogoClick.bind(this) },
	          _react2.default.createElement('img', { src: _logoWithText2.default, style: { height: 40 } })
	        )
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	Header.propTypes = {
	  onHeaderLogoClick: _propTypes2.default.func
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Changes icon styles on hover.
	var IconWrapper = function (_React$Component) {
	  _inherits(IconWrapper, _React$Component);
	
	  function IconWrapper(props) {
	    _classCallCheck(this, IconWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      hover: false
	    };
	    return _this;
	  }
	
	  IconWrapper.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        hoverStyle = _props.hoverStyle,
	        style = _props.style;
	
	    var iconStyle = this.state.hover ? _extends({}, style, hoverStyle) : style;
	    return _react2.default.createElement(
	      'div',
	      {
	        onMouseEnter: function onMouseEnter() {
	          return _this2.setState({ hover: true });
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this2.setState({ hover: false });
	        }
	      },
	      _react2.default.cloneElement(this.props.children, { style: iconStyle })
	    );
	  };
	
	  return IconWrapper;
	}(_react2.default.Component);
	
	IconWrapper.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  hoverStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object
	};
	
	IconWrapper.defaultProps = {
	  hoverStyle: {},
	  style: {}
	};
	
	exports.default = IconWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactfulSnippet = function (_React$Component) {
	  _inherits(ReactfulSnippet, _React$Component);
	
	  function ReactfulSnippet() {
	    _classCallCheck(this, ReactfulSnippet);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ReactfulSnippet.prototype.componentDidMount = function componentDidMount() {
	    if (!window) {
	      return;
	    }
	    var reactful_client_id = '329608';
	    window._rctfl = window._rctfl || { c: [] };
	    window._rctfl.c.push(reactful_client_id);
	    var el = window.document.createElement('script');
	    el.async = 1;
	    el.src = '//visitor.reactful.com/dist/main.rtfl.js';
	    window.document.getElementsByTagName('head')[0].appendChild(el);
	  };
	
	  ReactfulSnippet.prototype.render = function render() {
	    return null;
	  };
	
	  return ReactfulSnippet;
	}(_react2.default.Component);
	
	ReactfulSnippet.propTypes = {};
	
	ReactfulSnippet.defaultProps = {};
	
	exports.default = ReactfulSnippet;
	module.exports = exports['default'];

/***/ }),

/***/ 1768:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-grey.1d033414.svg";

/***/ }),

/***/ 1769:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-with-text.257bbffc.svg";

/***/ }),

/***/ 1770:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2dJREFUeNpiYMAF5nov/g+imdAlGIEy84F0AkwAIIBw64WxmdAFYYZOAAoKJG+NZQQIIEYsWg2B+DyIAVKAYgRIAEgJAHEjiA22A0gUoLnjAVCyAWQF2N1oLgQp3gDyB0gRSAwggAgiRqhOkM/nQ8UOALEDEF8AmmII81Y+1IGCIEkoeyIo2ECOBNnVCPXFB5jRQPYCkFuYoI4RAHkJOcRg1jEiCX6A+n8CLGxAVrFAJR2BeD9IEmplPRAnYoup/ehiAAFEMUKOTOSUAgorA2i8oXgKGoawkGBECWho+DFgib5+aAA04Eq0H6CCAViCsh5Kb8DmBVgoPoDS60GGQQ35APXCBKDNhTgCUxAU0wGwBAwFIE2JQE2CUH4BLGkiOR0UDoKglAGKaANoWkrElrFgNgHxeyg7EZqMqAMAAhBTbTcIwzAQRR0gbBA2KBMAG5RRMkInaFdggsIGbIA3gBEyArF0RicTxBfCqhS1ih89393/Hy/Zez2SI45KyVP4UHG4eiayaoQZhxCcPc6s4umQbGtcs2iJ3uo0W9dM2TkHqiqcDK7bapOb5ohCe/bfC1xh+AZcLXz2Xquxawip/+D+1qQE0oK52Yr86UZ+zTFhEgkN6S4OeQVWXIEXJgGdElfWjpjm5IGt900TG8OgNEASmONECbbWiI09rEAkHEba80zy1m+LWR5zooPTZKtYLxb8inUuSFbkC/nEuxZo1AgwddSM9+EnPvAUoP0quEEQCIJi/EMHagfQAXZgCXSAJViCJVgCHagVeFYgdmAJumbOLJPbO4kfH25CQmDD3e3Ozgy/RQdGOUrUL8fMndD5ztedcoUF5n4+n9dNaCWAxWgPEnboqxioDBNiTeTnIIgd5TXQO2aZASKRKzmtqBPlLiUvo8QrJyTaU4Av9EYqq9zQU0/Ur5HQXKJLLqfupacWoynHxTYoRqc6t2A+1pGDSuR0Z9xbUX8DiJm63ysfs4ET3vmTKmBKny+YioYcWJ/wvy1V8JhF0C+js0ILDgGrp+MOx9JF8LImqXiJshegrTr9JLHQygLZiMX3Xq8zRdQfL0w/DtFNBb4/8LlTIPOY2EABMDZq3p3x7t1OyNpabbRijIR+AtmJh1ixxwdLGjFn4MV0tNmIPtYo+yI037IAldvhuZv8IxIPclW1DnCBugMAAAAASUVORK5CYII="

/***/ }),

/***/ 1771:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/opengraph-img.6b4eabc7.png";

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(88);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(662);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(661);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ReactfulSnippet = __webpack_require__(667);
	
	var _ReactfulSnippet2 = _interopRequireDefault(_ReactfulSnippet);
	
	var _styles = __webpack_require__(274);
	
	var _theme = __webpack_require__(46);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _logo32x = __webpack_require__(1770);
	
	var _logo32x2 = _interopRequireDefault(_logo32x);
	
	var _opengraphImg = __webpack_require__(1771);
	
	var _opengraphImg2 = _interopRequireDefault(_opengraphImg);
	
	var _navigation = __webpack_require__(89);
	
	var _constants = __webpack_require__(284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* globals graphql */
	// Eventually will have eslint rules for Gatsby:
	// https://github.com/gatsbyjs/gatsby/issues/2446
	// Currently using linting recommendations from eslint,
	// Prettier, and React:
	// https://prettier.io/docs/en/eslint.html#why-not-both
	
	// Note that layouts will be deprecated in Gatsby V2:
	// https://github.com/gatsbyjs/gatsby/issues/3830
	
	// Use flexbox to make sure the footer sticks to the bottom of the page:
	// https://css-tricks.com/couple-takes-sticky-footer/#article-header-id-3
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        location = _props.location;
	
	    var absoluteUrl = (0, _navigation.getAbsoluteURL)(location.pathname);
	    var openGraphImgAbsolutePath = (0, _navigation.getAbsoluteURL)(_opengraphImg2.default);
	    return _react2.default.createElement(
	      _styles.MuiThemeProvider,
	      { theme: _theme2.default, sheetsManager: new Map() },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            flexDirection: 'column',
	            height: '100vh'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              flex: '1 0 auto'
	            }
	          },
	          _react2.default.createElement(
	            _reactHelmet2.default,
	            {
	              titleTemplate: '%s - ' + data.site.siteMetadata.title,
	              defaultTitle: data.site.siteMetadata.title
	            },
	            _react2.default.createElement('meta', {
	              name: 'description',
	              content: data.site.siteMetadata.descriptionLong
	            }),
	            _react2.default.createElement('meta', { name: 'keywords', content: data.site.siteMetadata.keywords }),
	            _react2.default.createElement('link', { rel: 'canonical', href: absoluteUrl }),
	            _react2.default.createElement('link', { rel: 'chrome-webstore-item', href: _constants.CHROME_WEB_STORE_HREF }),
	            _react2.default.createElement('link', { rel: 'icon', href: _logo32x2.default }),
	            _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	            _react2.default.createElement('meta', { property: 'fb:app_id', content: '774381839264847' }),
	            _react2.default.createElement('meta', { property: 'og:url', content: absoluteUrl }),
	            _react2.default.createElement('meta', {
	              property: 'og:title',
	              content: data.site.siteMetadata.metaTagCallToAction
	            }),
	            _react2.default.createElement('meta', {
	              property: 'og:description',
	              content: data.site.siteMetadata.descriptionShort
	            }),
	            _react2.default.createElement('meta', { property: 'og:image', content: openGraphImgAbsolutePath }),
	            _react2.default.createElement('meta', {
	              name: 'twitter:title',
	              content: data.site.siteMetadata.metaTagCallToAction
	            }),
	            _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }),
	            _react2.default.createElement('meta', {
	              name: 'twitter:description',
	              content: data.site.siteMetadata.descriptionShort
	            }),
	            _react2.default.createElement('meta', {
	              name: 'twitter:site',
	              content: data.site.siteMetadata.twitterHandle
	            }),
	            _react2.default.createElement('meta', {
	              name: 'twitter:creator',
	              content: data.site.siteMetadata.twitterHandle
	            }),
	            _react2.default.createElement('meta', { name: 'twitter:image', content: openGraphImgAbsolutePath }),
	            _react2.default.createElement('meta', { name: 'twitter:domain', content: _navigation.domain })
	          ),
	          _react2.default.createElement(_Header2.default, { siteTitle: data.site.siteMetadata.title }),
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                paddingTop: 0
	              }
	            },
	            this.props.children()
	          )
	        ),
	        _react2.default.createElement(_ReactfulSnippet2.default, null),
	        _react2.default.createElement(_Footer2.default, { style: { flexShrink: 0 } })
	      )
	    );
	  };
	
	  return Layout;
	}(_react2.default.Component);
	
	Layout.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        descriptionLong: _propTypes2.default.string.isRequired,
	        descriptionShort: _propTypes2.default.string.isRequired,
	        keywords: _propTypes2.default.string.isRequired,
	        metaTagCallToAction: _propTypes2.default.string.isRequired,
	        title: _propTypes2.default.string.isRequired,
	        twitterHandle: _propTypes2.default.string.isRequired
	      })
	    })
	  }),
	  location: _propTypes2.default.shape({
	    pathname: _propTypes2.default.string.isRequired
	  })
	};
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	// Browsers
	var CHROME_BROWSER = exports.CHROME_BROWSER = 'chrome';
	var FIREFOX_BROWSER = exports.FIREFOX_BROWSER = 'firefox';
	var UNSUPPORTED_BROWSER = exports.UNSUPPORTED_BROWSER = 'other';
	
	// localStorage keys
	var STORAGE_REFERRAL_DATA_REFERRING_USER = exports.STORAGE_REFERRAL_DATA_REFERRING_USER = 'tab.referralData.referringUser';
	var STORAGE_REFERRAL_DATA_REFERRING_CHANNEL = exports.STORAGE_REFERRAL_DATA_REFERRING_CHANNEL = 'tab.referralData.referringChannel';

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5df4c0c845fbe04afab1.js